import React, { useCallback,useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SetPage,SetUrlPrefix,SetImgPrefix,SetProducts,SetIsSearching,SetPrevProducts,SetAsyncData } from "../../state/actions/index";
import './Paginator.css';
import Utils from '../../utils/Utils';
import axios from 'axios';

const Paginator = () => {
  const activeFilters = useSelector(state => state.activeFilters);
  const searchWord = useSelector(state => state.searchWord);
  const card = useSelector(state => state.config.card);
  const configFilters = useSelector(state => state.config.filters);
  const sort = useSelector(state => state.sort);
  const accentColor = useSelector(state => state.config.accentColor);
  const products = useSelector(state => state.products);
  const isMobile = useSelector(state => state.isMobile);
  const pages = useSelector(state => state.pages);
  const page = useSelector(state => state.page);
  const config = useSelector(state => state.config);
  const dispatch = useDispatch();
  
  const queryOptions = useSelector(state => state.config.queryOptions);
  var rows=useMemo(()=>isMobile?queryOptions.rows.mobile:queryOptions.rows.desktop,[isMobile,queryOptions]);
  var selectedStyle=useMemo(()=>{ return {backgroundColor:accentColor,color:'white'}},[accentColor]);

  const setPage = useCallback((page) => {
    dispatch(SetPage(page));
    dispatch(SetIsSearching(true));
    dispatch(SetAsyncData([]));
    var priceGroup={}
    priceGroup.id=window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType?window.AS_ADVANCED_CONFIG.visitorType:config.priceGroup.id;
    priceGroup.currency=window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode?window.AS_ADVANCED_CONFIG.currencyCode:config.priceGroup.currency;
    var localSearchUrl=Utils.getSearchUrl(config.baseUrl,config.queryOptions,priceGroup,config.shopId,config.jsonFast);
    axios.get(Utils.insertWordInSearchUrl(localSearchUrl,searchWord,activeFilters,sort,page,configFilters,rows))
    .then(response=>{
      dispatch(SetPrevProducts(products));
      dispatch(SetProducts(Utils.refactorUrl(response.data.data,response.data.header.imagePrefix,response.data.header.urlPrefix,card.img,card.url)));
      dispatch(SetUrlPrefix(response.data.header.urlPrefix));
      dispatch(SetImgPrefix(response.data.header.imagePrefix));
      if(config.webhook.key!=='') Utils.getAsyncData(config.webhook,response.data,priceGroup).then(value=>dispatch(SetAsyncData(value.asyncData)));
      var websiteSearchBar= document.getElementById('accelasearch-bar-container-container');
      const event = new CustomEvent('as-search-event',{detail:{searchWord:searchWord,filters:activeFilters,page:page}});
      websiteSearchBar.dispatchEvent(event)
    })
    .finally(()=>dispatch(SetIsSearching(false)))
  },
    [dispatch,activeFilters,searchWord,sort,config,configFilters,products,rows,card]);

  return(
    <div className="paginator-container"> 
      <div className={"paginator"+(pages===1?' none':'')}>
        { page>1?<div className="left-arrow" onClick={()=>setPage(page-1)}></div>:null }
        { page>4?<div className="page" onClick={()=>setPage(1)}>1</div>:null}
        { page>4?<div className="dots" onClick={()=>setPage(Utils.stepPage(page)-1)}>...</div>:null}
        { pages>4?[1,2,3,4].map((item,index)=>
          // <div className={"page"+(Utils.lastStepPage(page,pages)+index===page?' selected':'')} key={'page_'+index} onClick={()=>setPage(Utils.lastStepPage(page,pages)+index)}> {Utils.lastStepPage(page,pages)+index} </div>
          <div style={Utils.lastStepPage(page,pages)+index===page?selectedStyle:null} className="page" key={'page_'+index} onClick={()=>setPage(Utils.lastStepPage(page,pages)+index)}> {Utils.lastStepPage(page,pages)+index} </div>
        ):Utils.createArrayOfIntegerFromOneToIndex(pages).map((item,index)=>
        <div style={item===page?selectedStyle:null} className={"page"+(item===page?' selected':'')} key={'page_'+index} onClick={()=>setPage(item)}> {item} </div>
        )}
        { page<pages-3?<div className="dots" onClick={()=>setPage(Utils.stepPage(page)+4)}>...</div>:null }
        { page<pages-3?<div className="page" onClick={()=>setPage(pages)}>{pages}</div>:null }
        { page<pages?<div className="right-arrow" onClick={()=>setPage(page+1)}></div>:null }
      </div>
    </div>
  )
};

export default Paginator;